import { Hooks } from '@yarnpkg/gatsby/src/components/hooks';
import * as React from 'react';
export default {
  Hooks,
  React
};